<template>
	<PlatformHeroSection />
	<Row>
		<Container>
			<section
				id="timeline"
				class="timeline"
			>
				<div class="timeline-progress-bar">
					<span
						class="timeline-progress-colored"
						:style="`height: ${counter}%;`"
					></span>
				</div>
				<div class="timeline-container">
					<TimelineBlock
						:id="'timeline-block-' + (i + 1)"
						v-for="(item, i) in platformData"
						:key="i"
						v-bind="item"
					/>
				</div>
			</section>
		</Container>
	</Row>
	<platform-scanners-pitch-grid-section-desktop />

	<TestimonialSlider />

	<!-- <IntroBrokerIntegration /> -->
	<!-- <PlatformSlider /> -->

	<!-- <platform-no-broker-account-section /> -->
	<faq-section />

	<SystemRequirementsSection />
	<Head>
		<Title>StocksToTrade | Platform</Title>
		<Meta
			name="description"
			content="Since 2009, StocksToTrade has helped new and seasoned traders make consistently profitable trades.  Try us today for only $7.00"
		/>

		<Link
			:href="config.current_hostname.slice(0, -1) + '/platform/'"
			rel="canonical"
		/>
		<Meta
			:content="config.current_hostname.slice(0, -1) + '/platform/'"
			property="og:url"
		/>
	</Head>
</template>

<script setup>
import anime from "animejs";

const config = useRuntimeConfig().public;
const router = useRoute();

const platformData = [
	{
		label: "NEWS TICKER",
		title: "Get Real-Time Data",
		description:
			"Find all the stock info you need quickly and easily on our platform. No more searching through search engines and dealing with ads. StocksToTrade gives you instant Level 1 data, including fast stock quotes, press releases, and social feeds. Make better trading decisions with speed and simplicity.",
		image: "/images/platform-1.webp"
	},
	{
		label: "SCREENERS",
		title: "Your Strategy + Powerful Screeners",
		description:
			"StocksToTrade helps you find the best stocks out of 19,000 each week. Use our easy screeners to make watchlists for different strategies. Follow pre-made screeners from expert traders to spot hot opportunities.",
		image: "/images/platform-2.webp"
	},
	{
		label: "ORACLE",
		title: "Discover Stocks With the Biggest Percent Gains",
		description:
			"Get all the info you need about a stock with just one click on our platform. No more searching and dealing with ads. StocksToTrade gives you fast data like stock quotes and company news instantly. Putting everything you need to trade in one place.",
		image: "/images/platform-3.webp"
	}
];
const counter = ref(0);

const breakpoints = reactive(
	useBreakpoints({
		small: 768
	})
);

function handleScroll() {
	const timelineElement = document.querySelector("#timeline");
	const rect = timelineElement.getBoundingClientRect();

	// Get the start and end positions of the element relative to the document
	const startOfElement = window.pageYOffset + rect.top - 600;
	const endOfElement = startOfElement + rect.height;

	const currentScrollPosition =
		window.pageYOffset || document.documentElement.scrollTop;

	// Check if the current scroll position is within the range of the element
	if (
		currentScrollPosition >= startOfElement &&
		currentScrollPosition <= endOfElement
	) {
		// Calculate scroll percentage within the element
		const scrollPercentage =
			((currentScrollPosition - startOfElement) / (rect.height + 900)) * 100;
		// Convert to scale of 1 to 100
		counter.value = Math.min(Math.max(1, scrollPercentage), 100);
	}
}

onMounted(() => {
	if (import.meta.client) {
		// Intersection Observer setup
		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.target.id === "timeline") {
					if (entry.isIntersecting) {
						// Add scroll listener here
						window.addEventListener("scroll", handleScroll);
					} else {
						// Remove scroll listener here
						window.removeEventListener("scroll", handleScroll);
					}
				}
			});
		});

		const timeline = document.querySelectorAll("#timeline, .timeline-block");

		timeline.forEach((element) => {
			observer.observe(element);
		});
	}
});
</script>

<style scoped lang="scss">
@use "~/assets/utils.scss" as *;

.timeline {
	position: relative;
}
.timeline-progress-bar {
	width: 4px;
	height: calc(100% - 140px);
	display: block;
	border-radius: 16px;
	background: rgba(255, 255, 255, 0.1);
	position: absolute;
}
.timeline-progress-colored {
	content: "";
	display: block;
	position: sticky;
	top: 0;
	width: 4px;
	background: linear-gradient(180deg, #de59ff 0%, rgba(0, 87, 255, 1) 75%);
	border-radius: 16px;
	justify-content: center;
	display: flex;
	align-items: flex-end;
	&::after {
		content: "";
		position: relative;
		display: block;
		min-height: 16px;
		min-width: 16px;
		background-color: white;
		border-radius: 24px;
		outline: 12px solid $black;
	}
}

.timeline-container {
	display: flex;
	flex-direction: column;
	gap: 0;

	@include breakpoint(lg) {
		gap: 64px;
	}
}
</style>
